import PropTypes from 'prop-types';

import { Announcement, getFormattedLongDate, parseLocalDate, ProgressBar } from '@utilities';

import styles from './_index.module.scss';

const SubscriptionOverviewV2 = ({ subscription }) => {
  if (!subscription) {
    return (
      <div>
        <Announcement
          header="No subscription information available."
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  if (!subscription?.hasStarted) {
    return (
      <div>
        <Announcement
          header={`Great news! Your subscription kicks off ${getFormattedLongDate(parseLocalDate(subscription.startDate))}`}
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  const currentPeriodEnd = new Date(subscription?.currentPeriod?.endDate);
  const nextSubscriptionPeriod = subscription?.subscriptionPeriods
    ?.filter((period) => {
      const periodStart = new Date(period.startDate);
      return periodStart > currentPeriodEnd;
    })
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))[0];

  return (
    <div className={styles['subscription-overview-usage-row-container']}>
      <section className={styles['subscription-overview-usage-row']}>
        <span>Completes</span>
        <span>
          <strong>
            {subscription?.currentPeriod?.usedCompletes?.toLocaleString()} /{' '}
            {subscription?.currentPeriod?.totalCompletes?.toLocaleString()} used
          </strong>
        </span>
      </section>
      <ProgressBar
        className={styles['subscription-overview-bar-neutral']}
        hasError={
          subscription?.currentPeriod?.totalCompletes > 0 &&
          subscription?.currentPeriod?.usedCompletes /
            subscription?.currentPeriod?.totalCompletes >=
            1
        }
        max={subscription?.currentPeriod?.totalCompletes}
        value={subscription?.currentPeriod?.usedCompletes}
      />
      <p className={styles['subscription-overview-remaining']}>
        {(
          subscription?.currentPeriod?.totalCompletes - subscription?.currentPeriod?.usedCompletes
        )?.toLocaleString()}{' '}
        remaining
      </p>
      <ul className={styles['subscription-overview-resets']}>
        <li>
          Period: {getFormattedLongDate(parseLocalDate(subscription?.currentPeriod?.startDate))} -{' '}
          {getFormattedLongDate(parseLocalDate(subscription?.currentPeriod?.endDate))}
        </li>
        {nextSubscriptionPeriod && (
          <li>
            Next reset:{' '}
            {nextSubscriptionPeriod?.startDate
              ? getFormattedLongDate(parseLocalDate(nextSubscriptionPeriod?.startDate))
              : 'N/A'}
          </li>
        )}
      </ul>
    </div>
  );
};

SubscriptionOverviewV2.propTypes = {
  subscription: PropTypes.object,
};

export default SubscriptionOverviewV2;
